import { useState, type FC } from 'react'

import { Modal } from '@/components/elements'
import { MENU } from '@/constants/common/message.constants'
import {
  type ShipmentOrdersListExEntity,
  type UserMeExEntity
} from '@/libs/api'

import { ShipmentOrderFormModalContent } from './ShipmentOrderFormModalContent'

type Props = {
  authUser: UserMeExEntity
  tenantKey: string
  shipmentOrder: ShipmentOrdersListExEntity
  onClose: () => void
  onSuccess: () => void | Promise<void>
}

/**
 * 配送依頼一覧の編集モーダル。
 * 配車板の編集モーダル（atom 駆動）と同じ Content を再利用しつつ、
 * 対象依頼を props で受け取り、保存成功時の再取得を呼び出し側に委ねる。
 */
export const ShipmentOrderEditModal: FC<Props> = ({
  authUser,
  tenantKey,
  shipmentOrder,
  onClose,
  onSuccess
}) => {
  // 保存中はモーダルを閉じられないようにするためのState
  const [isCancelDisabled, setIsCancelDisabled] = useState(false)

  return (
    <Modal
      title={MENU.EDITING_SHIPMENT_ORDER}
      width={860}
      open
      onCancel={isCancelDisabled ? undefined : onClose}
      centered
    >
      <ShipmentOrderFormModalContent
        authUser={authUser}
        tenantKey={tenantKey}
        shipmentOrder={shipmentOrder}
        onSuccess={onSuccess}
        onClose={onClose}
        setIsCancelDisabled={setIsCancelDisabled}
        mode="notDispatchedUpdate"
      />
    </Modal>
  )
}
